import React from 'react';
import {Alert, AlertTitle, Typography} from '@mui/material';
import {Sx} from 'app/types/common';

type Variant = 'go' | 'eu';

interface Props extends Sx {
  variant: Variant;
}

export function EnvNotice({sx, variant}: Props) {
  const altDomain = variant === 'go' ? 'eu' : 'go';

  return (
    <Alert sx={sx} severity="info">
      <AlertTitle>This is Epiphan Cloud for {variant === 'go' ? 'US' : 'EU'} region</AlertTitle>

      <Typography variant="inherit">
        Epiphan Cloud accounts in the EU and US regions are separate and isolated. You can't share
        accounts or logins between them.
      </Typography>

      <Typography variant="inherit" mt={1}>
        Epiphan Cloud {altDomain === 'go' ? 'USA' : 'Europe'}:{' '}
        <a href={`https://${altDomain}.epiphan.cloud`}>{altDomain}.epiphan.cloud</a>
      </Typography>
    </Alert>
  );
}
